import { JobPostings } from '@platform/client';
import { Icon } from '@platform/components';
import { useState } from 'react';
import { PaginationBar } from '../../../components/PaginationBar';
import { CommunityBackButton } from '../community-home/CommunityBackButton';
import { CommunityCard } from '../CommunityCard';
import { CommunityListPanel } from '../CommunityListPanel';

export const JobPostingsPage = () => {
  const [page, setPage] = useState(0);
  const [pageSize, _] = useState(8);

  const onPageSelect = (page: number) => {
    setPage(page - 1);
  };

  const previewJobPostings = JobPostings.useGetJobPostings({ page, limit: pageSize });
  const numJobPostings = JobPostings.useCountJobPostings();
  const numPages = Math.ceil((numJobPostings.data || pageSize) / pageSize);

  return (
    <div className='w-full p-4 flex flex-col pt-10 w-[317px] max-w-[317px] md:w-[798px] md:max-w-[798px]'>
      <CommunityBackButton />
      <h1 className='text-display-sm font-gray-700 py-10'>Social impact job openings</h1>
      <CommunityListPanel>
        {previewJobPostings.data?.map((jobPosting) => {
          return (
            <CommunityCard
              title={jobPosting.title}
              key={jobPosting.id}
              description={jobPosting.description}
              date={new Date(jobPosting.date)}
              subheader={
                <div className={'flex justify-left gap-1 items-center'}>
                  <Icon size='16' type='marker-pin-01' />
                  {jobPosting.location}
                </div>
              }
              link={jobPosting.url ?? undefined}
              cta={'Read More'}
            />
          );
        })}
      </CommunityListPanel>
      <PaginationBar onPageSelect={onPageSelect} currentPage={page + 1} numPages={numPages} />
    </div>
  );
};
